

export const OptionType = {
    Call:0,Put:1
}
export const OptionStrategy = {
    CreditSpread:0,DebitSpread:1
}
export function strategyName(s) {
     switch (parseInt(s)) {
        case OptionStrategy.CreditSpread:
            return "credit spread"
        case OptionStrategy.DebitSpread:
            return "debit spread"
        default:
            return ""
     }
}
export function optionName(o){
    switch (parseInt(o)){
        case OptionType.Call: return "Call"
        case OptionType.Put: return "Put"
        default: return ""
    }
}